<i18n>
{
	"en": {
		"maintenanceSync": "Maintenance: Synchronization",
		"globalAddresses": "global addresses",
		"orderTypes": "order types",
		"incoterms": "incoterms",
		"drivers": "drivers",
		"cargoCarriers": "cargo carriers",
		"cargoCarrierTypes": "cargo carrier types",
		"goodsTypes": "goods types",
		"packageTypes": "package types",
		"tripTypes": "trip types",
		"customers": "customers",

		"syncStartedSuccess": "{moduleName} sync started successfully",
		"syncStartedFail": "Unable to start {moduleName} sync",
		"import": "Import {moduleName} from TMS",
		"delete": "Delete all {moduleName}",
		"confirmDelete": "Delete",
		"cancelDelete": "Cancel",
		"confirmationDialogText": "Are you sure you want to delete all {moduleName}?",
		"deleteStartedSuccess": "Deleting all {moduleName}",
		"deleteStartedFail": "An error occured when deleting {moduleName}"
	},
	"no": {
		"maintenanceSync": "Vedlikehold: Synkronisering",
		"globalAddresses": "globale adresser",
		"orderTypes": "oppdragstyper",
		"incoterms": "incoterms",
		"drivers": "sjåfører",
		"cargoCarriers": "lastebærere",
		"cargoCarrierTypes": "lastebærertyper",
		"goodsTypes": "godstyper",
		"packageTypes": "pakketyper",
		"tripTypes": "turtyper",
		"customers": "kunder",

		"syncStartedSuccess": "Synkronisering av {moduleName} startet",
		"syncStartedFail": "Kunne ikke starte synkronisering av {moduleName}",
		"import": "Importer {moduleName} fra TMS",
		"delete": "Slett alle {moduleName}",
		"confirmDelete": "Slett",
		"cancelDelete": "Avbryt",
		"confirmationDialogText": "Er du sikker på at du vil slette alle {moduleName}?",
		"deleteStartedSuccess": "Sletter alle {moduleName}",
		"deleteStartedFail": "Feil oppsto ved sletting av {moduleName}"
	}
}
</i18n>

<template>
	<div class="general–settings">
		<t-form-group :title="$t('maintenanceSync')">
			<div class="grid-inner">
				<template v-for="moduleName in modules">
					<span :key="moduleName + 'title'">{{ capitalizeFirstLetter($t(moduleName)) }}:</span>
					<t-button
						:key="moduleName + 'delete'"
						iconBefore="trash"
						appearance="primary"
						intent="danger"
						@click="openConfirmDeleteDialog(moduleName)"
					>{{$t('delete', { moduleName: $t(moduleName) })}}</t-button>
					<t-button
						:key="moduleName + 'import'"
						iconBefore="import"
						@click="onSync(moduleName)"
					>{{$t('import', { moduleName: $t(moduleName) })}}</t-button>
				</template>
			</div>
		</t-form-group>
		<t-dialog
			:isShown="confirmDeleteShown"
			:hasHeader="false"
			:confirmLabel="$t('confirmDelete')"
			:cancelLabel="$t('cancelDelete')"
			intent="danger"
			icon="cog"
			iconType="bp"
			width="480px"
			@ok="onConfirmDelete"
			@close="onDialogClose"
		>
			{{$t('confirmationDialogText', { moduleName: $t(currentModuleName) })}}
		</t-dialog>
	</div>
</template>

<script>
import { mapActions } from './store/settings.store.js';
export default {
	name: 'Tms',
	filters: {
	},
	data() {
		return {
			confirmDeleteShown: false,
			currentModuleName: undefined,
			modules: [
				'globalAddresses',
				'orderTypes',
				'incoterms',
				'drivers',
				'cargoCarriers',
				'cargoCarrierTypes',
				'goodsTypes',
				'packageTypes',
				'tripTypes',
				'customers',
			],
		};
	},
	methods: {
		...mapActions(['syncModule' ,'deleteModule',]),
		onDialogClose() {
			this.confirmDeleteShown = false;
			this.currentModuleName = undefined;
		},
		openConfirmDeleteDialog(moduleName) {
			this.currentModuleName = moduleName;
			this.confirmDeleteShown = true;
		},
		async onConfirmDelete() {
			try {
				await this.deleteModule(this.currentModuleName);
				this.$notify({
					type: 'success',
					title: this.$t('deleteStartedSuccess', { moduleName: this.$t(this.currentModuleName) }),
				});
			} catch (e) {
				this.$notify({
					type: 'error',
					title: this.$t('deleteStartedFail', { moduleName: this.$t(this.currentModuleName) }),
					text: e.message
				});
			}
		},
		async onSync(moduleName) {
			try {
				await this.syncModule(moduleName);
				this.$notify({
					type: 'success',
					title: this.$t('syncStartedSuccess', { moduleName: this.$t(moduleName) }),
				});
			} catch (e) {
				this.$notify({
					type: 'error',
					title: this.$t('syncStartedFail', { moduleName: this.$t(moduleName) }),
					text: e.message
				});
			}
		},
		capitalizeFirstLetter(str) {
			return str.charAt(0).toUpperCase() + str.slice(1);
		}
	},
};
</script>

<style lang="scss" scoped>
	.general–settings {
		display: grid;
		grid-template-columns: auto;
		row-gap: 20px;
	}

	.grid-inner {
		display: grid;
		grid-template-columns: repeat(3, max-content);
		align-content: center;
		row-gap: 20px;
		column-gap: 10px;

		& span {
			font-size: 12px;
			font-weight: 500;
			font-style: normal;
			font-stretch: normal;
			line-height: 2.5;
			letter-spacing: normal;
		}
	}
</style>
